import React, {
  useEffect,
} from 'react';
import {
  useDispatch,
} from 'react-redux';
import {
  toast,
} from 'react-toastify';
import {
  useNavigate,
  useLocation,
} from 'react-router-dom';

import {
  coreActions,
} from '@gymcloud/core';

import {
  decodeParam,
} from 'web-utils';

import {
  Spinner,
} from 'web-components';

const StripeConnected = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const qs = decodeParam(location.search);
    dispatch(
      coreActions.requestStripeConnect({
        qs,
        callbacks: {
          onSuccess: () => {
            toast('successful connection');
            navigate('/welcome');
          },
        },
      }),
    );
  }, []);

  return (<Spinner />);
};

export default StripeConnected;
